import { __assign, __rest } from "tslib";
import * as React from 'react';
import { Picker } from '../Picker';
export var TagPicker = function (props) {
    var theme = props.theme, other = __rest(props, ["theme"]);
    return React.createElement(Picker, __assign({ tabSelectsValue: false }, other));
};
TagPicker.defaultProps = {
    isMulti: true,
    isSearchable: true,
    placeholder: '',
};
export default TagPicker;
//# sourceMappingURL=TagPicker.js.map